<div class="main-content inventory-upload-page">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-5">
						<h4 class="card-title mb-0 d-flex align-items-center">
							<i class="material-icons inv-upload-back" (click)="back()" (keydown.enter)="back()" tabindex="0" role="button">arrow_back</i>
							<span class="ml-1">Batch cost update</span>
						</h4>
					</div>

					<div class="card-body p-0">

						<mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="150ms" class="bcu-tab-group">

							<!-- ═══════════════════════════════════════════════════════ TAB 1: Batch Update -->
							<mat-tab label="Batch Update">

						<!-- Toolbar -->
						<div class="d-flex justify-content-between align-items-center flex-wrap px-3 pt-3 mb-1">
							<div class="text-muted small mb-0">
								<ng-container *ngIf="step === 'upload' && !files.length">
									Drop a CSV or Excel file to begin.
								</ng-container>
								<ng-container *ngIf="files.length">
									<span class="font-weight-bold text-dark">{{ files[0].name }}</span>
									<ng-container *ngIf="uploaddata.length"> · {{ uploaddata.length }} row(s)</ng-container>
								</ng-container>
								<ng-container *ngIf="step === 'dry_running' || step === 'dry_results'">
									&nbsp;·&nbsp;<span class="text-primary">Dry run — <strong>{{ selectedCostFieldLabel }}</strong></span>
								</ng-container>
								<ng-container *ngIf="step === 'posting' || step === 'done'">
									&nbsp;·&nbsp;<span class="text-success">Posting — <strong>{{ selectedCostFieldLabel }}</strong></span>
								</ng-container>
							</div>
						</div>

						<!-- Step breadcrumb -->
						<div class="d-flex align-items-center px-3 pb-2 bcu-steps">
							<span class="bcu-step" [ngClass]="{ 'bcu-step--active': step === 'upload', 'bcu-step--done': step !== 'upload' }">
								<mat-icon class="bcu-step-icon">upload_file</mat-icon> Upload
							</span>
							<span class="bcu-step-sep">›</span>
							<span class="bcu-step" [ngClass]="{ 'bcu-step--active': step === 'mapping', 'bcu-step--done': step !== 'upload' && step !== 'mapping' }">
								<mat-icon class="bcu-step-icon">tune</mat-icon> Map
							</span>
							<span class="bcu-step-sep">›</span>
							<span class="bcu-step" [ngClass]="{ 'bcu-step--active': step === 'dry_running' || step === 'dry_results', 'bcu-step--done': step === 'posting' || step === 'done' }">
								<mat-icon class="bcu-step-icon">preview</mat-icon> Dry run
							</span>
							<span class="bcu-step-sep">›</span>
							<span class="bcu-step" [ngClass]="{ 'bcu-step--active': step === 'posting' || step === 'done' }">
								<mat-icon class="bcu-step-icon">cloud_done</mat-icon> Finalize
							</span>
						</div>

						<div class="inv-upload-body w-100 px-3 pb-2">

							<!-- ══ STEP: upload ══ -->
							<ng-container *ngIf="step === 'upload'">
								<div class="row">
									<div class="col-lg-5 mb-3">
										<mat-card class="inv-upload-panel h-100">
											<mat-card-subtitle class="inv-upload-card-heading">About</mat-card-subtitle>
											<mat-card-content>
												<p class="text-muted small mb-3">
													Update <strong>cost fields</strong> on <code>stockmaster</code> in bulk.
													Map item number (or brand + part), choose the target cost field,
													run a dry run to preview every change, then finalize.
												</p>
												<p class="text-muted small mb-3">
													Cost fields available: <code>materialcost</code>, <code>labourcost</code>,
													<code>overheadcost</code>, <code>actualcost</code>.
												</p>
												<button mat-stroked-button type="button" (click)="downloadTemplate()" [disabled]="processing_recs">
													<mat-icon>file_download</mat-icon>
													Download template
												</button>
											</mat-card-content>
										</mat-card>
									</div>
									<div class="col-lg-7 mb-3">
										<mat-card class="inv-upload-panel h-100">
											<mat-card-subtitle class="inv-upload-card-heading">File &amp; header row</mat-card-subtitle>
											<mat-card-content>
												<mat-form-field appearance="outline" class="w-100 inv-upload-header-row-field">
													<mat-label>Header row #</mat-label>
													<input matInput type="number" min="1" [formControl]="rowNumber" />
													<mat-hint>Adjust if column headings are not on row 1.</mat-hint>
												</mat-form-field>

												<div *ngIf="!processing_recs">
													<ngx-dropzone
														class="inv-upload-dropzone"
														[ngClass]="'inv-upload-dropzone--' + dropzoneThemeColor"
														[multiple]="false"
														[expandable]="true"
														accept=".csv,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/plain"
														(change)="onSelect($event)">
														<ngx-dropzone-label>
															<div class="order-upload-dropzone__inner">
																<mat-icon class="order-upload-dropzone__icon" aria-hidden="true">cloud_upload</mat-icon>
																<span class="order-upload-dropzone__title">Drop one file here</span>
																<span class="order-upload-dropzone__hint">CSV or Excel (.xlsx, .xls) — first sheet only.</span>
															</div>
														</ngx-dropzone-label>
														<ngx-dropzone-preview *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
															<ngx-dropzone-label class="order-upload-file-label">{{ f.name }} · {{ formatFileSizeKb(f.size) }} KB</ngx-dropzone-label>
														</ngx-dropzone-preview>
													</ngx-dropzone>
												</div>

												<div class="order-upload-processing text-center py-4" *ngIf="processing_recs">
													<mat-spinner diameter="40" class="order-upload-processing__spinner"></mat-spinner>
													<p class="mt-2 text-muted small mb-0 order-upload-processing__hint">Reading file…</p>
												</div>
											</mat-card-content>
										</mat-card>
									</div>
								</div>
							</ng-container>

							<!-- ══ STEP: mapping ══ -->
							<ng-container *ngIf="step === 'mapping'">
								<!-- Loaded file bar -->
								<div class="d-flex align-items-center flex-wrap mb-3 inv-upload-loaded-file">
									<mat-icon class="text-success mr-1" style="font-size: 20px; width: 20px; height: 20px;">insert_drive_file</mat-icon>
									<span class="small text-dark mr-2 text-truncate" style="max-width: 280px;">{{ files[0]?.name }}</span>
									<button mat-stroked-button type="button" color="warn" class="py-0 mr-2" (click)="clearFile()">
										<mat-icon>close</mat-icon> Remove
									</button>
									<button mat-stroked-button type="button" class="py-0" (click)="rereadFile()">
										<mat-icon>refresh</mat-icon> Re-read
									</button>
								</div>

								<!-- Target cost field -->
								<mat-card class="inv-upload-panel mb-3">
									<mat-card-subtitle class="inv-upload-card-heading">Target cost field</mat-card-subtitle>
									<mat-card-content>
										<p class="text-muted small mb-2">Which <code>stockmaster</code> cost field should be updated?</p>
										<mat-form-field appearance="outline">
											<mat-label>Cost field</mat-label>
											<mat-select [(ngModel)]="selectedCostField" (ngModelChange)="onCostFieldChange()">
												<mat-option *ngFor="let opt of costFieldOptions" [value]="opt.value">
													{{ opt.label }}
													<span class="text-muted small ml-1">({{ opt.value }})</span>
												</mat-option>
											</mat-select>
										</mat-form-field>
										<div *ngIf="postGlNote" class="alert alert-warning py-2 mt-1">
											<div class="d-flex align-items-start">
												<mat-icon class="flex-shrink-0 mr-2 text-warning">account_balance</mat-icon>
												<div class="small mb-0">
													<strong>GL revaluation will be posted.</strong> When <code>materialcost</code> changes and items are on hand,
													inventory (13100) is debited/credited for the cost difference × QOH, with the offset posting to the account below.
												</div>
											</div>
											<mat-form-field appearance="outline" class="mt-2 mb-0 w-100">
												<mat-label>Revaluation offset account</mat-label>
												<mat-select [(ngModel)]="glOffsetAccount">
													<mat-option [value]="''">System default (per configuration)</mat-option>
													<mat-option *ngFor="let a of glAccounts" [value]="a.accountcode">
														{{ a.accountcode }} — {{ a.accountname }}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
										<div *ngIf="isPurchpriceMode" class="alert alert-info d-flex align-items-start py-2 mt-1">
											<mat-icon class="flex-shrink-0 mr-2">local_shipping</mat-icon>
											<div class="small mb-0">
												Updates <code>purchdata.price</code> and sets <code>effectivefrom</code> to today.
												Map <strong>Supplier #</strong> to target a specific supplier; otherwise the preferred supplier record is updated.
												No GL entries are generated for purchase price changes.
											</div>
										</div>
									</mat-card-content>
								</mat-card>

								<!-- Column mapping -->
								<mat-card class="inv-upload-panel mb-3" *ngIf="uploaddata.length">
									<mat-card-subtitle class="inv-upload-card-heading">Map columns</mat-card-subtitle>
									<mat-card-content>
										<div class="alert alert-info d-flex align-items-start py-2 mb-3">
											<mat-icon class="flex-shrink-0 mr-2">auto_awesome</mat-icon>
											<div class="small mb-0">
												Map <strong>New cost value</strong> (required). Map <strong>Item number</strong>,
												or map both <strong>Brand</strong> and <strong>Manufacturer part number</strong> to resolve items automatically.
											</div>
										</div>

										<div class="d-flex flex-wrap align-items-center mb-3">
											<button mat-stroked-button type="button" color="primary" (click)="suggestMappings()">
												<mat-icon>psychology</mat-icon>
												Suggest mappings
											</button>
										</div>

										<div *ngIf="mappingPreviewTotal > mappingPreviewMax" class="alert alert-secondary small py-2 mb-2">
											Showing the first {{ mappingPreviewMax }} of {{ mappingPreviewTotal }} row(s). Dry Run uses every row.
										</div>

										<div class="table-responsive inv-upload-mapping-table-wrap" [ngClass]="'inv-upload-mapping-table-wrap--' + dropzoneThemeColor">
											<table class="table table-bordered table-sm inv-upload-mapping-table mb-0">
												<thead>
													<tr>
														<th *ngFor="let h of fileColumnsForMapping" class="inv-upload-mapping-th-title text-muted small" [attr.title]="h">
															<span class="inv-upload-mapping-th-text">{{ h }}</span>
														</th>
													</tr>
													<tr>
														<th *ngFor="let h of fileColumnsForMapping" class="inv-upload-mapping-th-select p-1">
															<div class="inv-upload-select-wrap">
																<select
																	class="inv-upload-mapping-select"
																	[ngClass]="'inv-upload-mapping-select--' + dropzoneThemeColor"
																	[ngModel]="getSystemFieldForFileHeader(h)"
																	(ngModelChange)="onFileColumnMappingChange(h, $event)"
																	[ngModelOptions]="{ standalone: true }">
																	<option value="">— Not used —</option>
																	<option *ngFor="let m of mapcols" [value]="m.field" [disabled]="isFieldMappedToOtherHeader(m.field, h)">
																		{{ m.label }}<ng-container *ngIf="m.req"> *</ng-container>
																	</option>
																</select>
															</div>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let row of mappingPreviewRows">
														<td *ngFor="let h of fileColumnsForMapping" class="inv-upload-mapping-td small">{{ row[h] }}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</mat-card-content>
								</mat-card>
							</ng-container>

							<!-- ══ STEP: dry_running ══ -->
							<ng-container *ngIf="step === 'dry_running'">
								<div class="text-center py-5">
									<mat-spinner diameter="52" class="order-upload-processing__spinner"></mat-spinner>
									<p class="mt-3 font-weight-bold mb-1">Running dry run…</p>
									<p class="small text-muted mb-3 order-upload-processing__hint">
										Batch {{ dryRunCurrentBatch }} of {{ dryRunTotalBatches }}
										— {{ dryRunProcessed }} rows validated so far.
									</p>
									<div class="progress mx-auto bcu-progress-bar mb-2">
										<div
											class="progress-bar"
											role="progressbar"
											[style.width.%]="dryRunProgressPct"
											[attr.aria-valuenow]="dryRunProgressPct"
											aria-valuemin="0"
											aria-valuemax="100">
											{{ dryRunProgressPct }}%
										</div>
									</div>
									<p class="small text-muted">No changes are written during dry run.</p>
								</div>
							</ng-container>

							<!-- ══ STEP: dry_results ══ -->
							<ng-container *ngIf="step === 'dry_results'">
								<!-- Summary badges -->
								<div class="d-flex flex-wrap align-items-center mb-3 bcu-summary-chips">
									<span class="badge badge-success bcu-badge mr-2">
										<mat-icon class="bcu-badge-icon">upgrade</mat-icon>
										Would update: {{ dryRunSummary.wouldUpdate }}
									</span>
									<span class="badge badge-secondary bcu-badge mr-2">
										<mat-icon class="bcu-badge-icon">check</mat-icon>
										Already same: {{ dryRunSummary.alreadySame }}
									</span>
									<span class="badge badge-warning bcu-badge mr-2" *ngIf="dryRunSummary.notFound">
										<mat-icon class="bcu-badge-icon">help_outline</mat-icon>
										Not found: {{ dryRunSummary.notFound }}
									</span>
									<span class="badge badge-danger bcu-badge mr-2" *ngIf="dryRunSummary.invalid">
										<mat-icon class="bcu-badge-icon">error_outline</mat-icon>
										Invalid: {{ dryRunSummary.invalid }}
									</span>
									<span class="text-muted small ml-2">
										Field: <strong>{{ selectedCostFieldLabel }}</strong>
									</span>
								</div>

								<mat-card class="inv-upload-panel mb-3">
									<mat-card-subtitle class="inv-upload-card-heading">Dry run results</mat-card-subtitle>
									<mat-card-content class="p-0 pt-2">
										<div *ngIf="dryRunResults.length > dryRunPreviewMax" class="alert alert-secondary small py-2 mx-3 mb-2">
											Showing the first {{ dryRunPreviewMax }} of {{ dryRunResults.length }} rows.
											Finalize applies all <strong>{{ dryRunSummary.wouldUpdate }}</strong> pending updates.
										</div>
										<div class="table-responsive inv-upload-preview-wrap">
											<table class="table table-striped table-sm inv-upload-preview-table mb-0">
												<thead>
													<tr>
														<th>Status</th>
														<th>Item #</th>
														<th *ngIf="isPurchpriceMode">Supplier #</th>
														<th>Current {{ selectedCostFieldLabel }}</th>
														<th>Proposed</th>
														<th>Problem</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let row of dryRunPreviewRows"
														[ngClass]="{
															'hasProblem': row.status === 'notfound' || row.status === 'invalid',
															'bcu-row-update': row.status === 'update'
														}">
														<td class="small">
															<span *ngIf="row.status === 'update'" class="text-success font-weight-bold">UPDATE</span>
															<span *ngIf="row.status === 'same'" class="text-muted">same</span>
															<span *ngIf="row.status === 'notfound'" class="text-warning font-weight-bold">not found</span>
															<span *ngIf="row.status === 'invalid'" class="text-danger font-weight-bold">invalid</span>
														</td>
														<td class="small font-weight-bold">{{ row.stockid }}</td>
														<td *ngIf="isPurchpriceMode" class="small text-muted">{{ row.supplierno }}</td>
														<td class="small text-muted">{{ row.currentCost }}</td>
														<td class="small font-weight-bold text-dark">{{ row.proposedCost }}</td>
														<td class="small text-danger">{{ row.problem }}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</mat-card-content>
								</mat-card>
							</ng-container>

							<!-- ══ STEP: posting ══ -->
							<ng-container *ngIf="step === 'posting'">
								<div class="text-center py-5">
									<mat-spinner diameter="52" class="order-upload-processing__spinner"></mat-spinner>
									<p class="mt-3 font-weight-bold mb-1">Applying cost updates…</p>
									<p class="small text-muted mb-3 order-upload-processing__hint">
										Batch {{ postCurrentBatch }} of {{ postTotalBatches }}
										— {{ postUpdated }} updated so far.
									</p>
									<div class="progress mx-auto bcu-progress-bar mb-2">
										<div
											class="progress-bar bg-success"
											role="progressbar"
											[style.width.%]="postProgressPct"
											[attr.aria-valuenow]="postProgressPct"
											aria-valuemin="0"
											aria-valuemax="100">
											{{ postProgressPct }}%
										</div>
									</div>
								</div>
							</ng-container>

							<!-- ══ STEP: done ══ -->
							<ng-container *ngIf="step === 'done'">
								<div class="text-center py-5">
									<mat-icon class="bcu-done-icon text-success">check_circle</mat-icon>
									<p class="mt-2 mb-3" style="font-size: 1.1rem; font-weight: 600;">Cost update complete</p>
									<div class="bcu-summary-box mx-auto text-left">
										<div *ngFor="let line of postSummaryLines; let last = last"
											class="small py-2"
											[class.border-bottom]="!last">
											{{ line }}
										</div>
									</div>
								</div>
							</ng-container>

						</div><!-- /.inv-upload-body -->

						<!-- Footer actions -->
						<div class="inv-upload-footer d-flex flex-wrap align-items-center justify-content-end px-3 py-3 border-top">

							<ng-container *ngIf="step === 'mapping'">
								<button mat-stroked-button type="button" (click)="clearFile()">
									Back
								</button>
								<button
									mat-raised-button
									color="primary"
									type="button"
									[disabled]="!canRunDryRun || isDryRunning"
									(click)="startDryRun()">
									<mat-icon>preview</mat-icon>
									Dry Run
								</button>
							</ng-container>

							<ng-container *ngIf="step === 'dry_results'">
								<button mat-stroked-button type="button" (click)="backToMapping()">
									Back to mapping
								</button>
								<button
									mat-raised-button
									color="accent"
									type="button"
									[disabled]="dryRunSummary.wouldUpdate === 0 || isPosting"
									(click)="startPosting()">
									<mat-icon>cloud_upload</mat-icon>
									Finalize — Update {{ dryRunSummary.wouldUpdate }} item(s)
								</button>
							</ng-container>

							<ng-container *ngIf="step === 'done'">
								<button mat-raised-button color="primary" type="button" (click)="startOver()">
									<mat-icon>add</mat-icon>
									Start another upload
								</button>
							</ng-container>

						</div>

							</mat-tab><!-- /Tab 1: Batch Update -->

							<!-- ═══════════════════════════════════════════════════════ TAB 2: Cost Report -->
							<mat-tab label="Cost Report">
								<div class="px-3 py-3">

									<!-- Filters -->
									<mat-card class="inv-upload-panel mb-3">
										<mat-card-subtitle class="inv-upload-card-heading">Filters</mat-card-subtitle>
										<mat-card-content>
											<div class="d-flex flex-wrap align-items-center bcu-filter-row" [formGroup]="costReportFilterForm">
												<mat-form-field appearance="outline" class="bcu-filter-field">
													<mat-label>Brand</mat-label>
													<mat-select formControlName="mfgname" multiple appSelectAll>
														<mat-option *ngFor="let b of costReportBrands" [value]="b.manufacturer_id">{{ b.name }}</mat-option>
													</mat-select>
												</mat-form-field>
												<mat-form-field appearance="outline" class="bcu-filter-field">
													<mat-label>Product Line</mat-label>
													<mat-select formControlName="lineid" multiple appSelectAll>
														<mat-option *ngFor="let l of costReportLines" [value]="l.line_field">{{ l.line_description }}</mat-option>
													</mat-select>
												</mat-form-field>
												<mat-form-field appearance="outline" class="bcu-filter-field">
													<mat-label>Category</mat-label>
													<mat-select formControlName="categoryid" multiple appSelectAll>
														<mat-option *ngFor="let c of costReportCategories" [value]="c.categoryid">{{ c.categorydescription }}</mat-option>
													</mat-select>
												</mat-form-field>
												<mat-form-field appearance="outline" class="bcu-filter-field">
													<mat-label>Discontinued</mat-label>
													<mat-select formControlName="discontinued">
														<mat-option value="">All</mat-option>
														<mat-option value="0">Active only</mat-option>
														<mat-option value="1">Discontinued only</mat-option>
													</mat-select>
												</mat-form-field>
												<mat-form-field appearance="outline" class="bcu-filter-field bcu-filter-field--narrow">
													<mat-label>Low margin %</mat-label>
													<input matInput type="number" formControlName="lowMargin" placeholder="e.g. 20" />
												</mat-form-field>
											</div>
											<div class="d-flex align-items-center flex-wrap gap-2">
												<button mat-raised-button color="primary" type="button" (click)="loadCostReport()" [disabled]="costReportLoading">
													<mat-icon>search</mat-icon>
													{{ costReportLoading ? 'Loading…' : 'Load report' }}
												</button>
												<ng-container *ngIf="costReportRows.length">
													<button mat-stroked-button type="button" (click)="exportCostReportXls()" class="ml-2" [disabled]="exportingXls">
														<mat-spinner *ngIf="exportingXls" diameter="16" class="d-inline-block mr-1" style="vertical-align:middle;"></mat-spinner>
														<mat-icon *ngIf="!exportingXls">table_view</mat-icon>
														{{ exportingXls ? 'Exporting…' : 'Export XLS' }}
													</button>
													<button mat-stroked-button type="button" (click)="exportCostReportPdf()" class="ml-2" [disabled]="exportingPdf">
														<mat-spinner *ngIf="exportingPdf" diameter="16" class="d-inline-block mr-1" style="vertical-align:middle;"></mat-spinner>
														<mat-icon *ngIf="!exportingPdf">picture_as_pdf</mat-icon>
														{{ exportingPdf ? 'Exporting…' : 'Export PDF' }}
													</button>
												</ng-container>
											</div>
										</mat-card-content>
									</mat-card>

									<!-- Loading spinner -->
									<div class="text-center py-4" *ngIf="costReportLoading">
										<mat-spinner diameter="44" class="order-upload-processing__spinner"></mat-spinner>
										<p class="mt-2 text-muted small mb-0">Loading cost report…</p>
									</div>

									<!-- Results table -->
									<ng-container *ngIf="!costReportLoading && costReportRows.length">
										<div class="d-flex align-items-center mb-2">
											<span class="small text-muted">{{ costReportRows.length }} item(s)</span>
										</div>
										<div class="table-responsive bcu-cost-report-table-wrap">
											<table class="table table-striped table-sm bcu-cost-report-table mb-0">
												<thead>
													<tr>
														<th>Item #</th>
														<th>Description</th>
														<th>Brand</th>
														<th>Line</th>
														<th>Category</th>
														<th>Material</th>
														<th>Labour</th>
														<th>Overhead</th>
														<th>Actual</th>
														<th>Xref</th>
														<th>Last</th>
														<th>QOH</th>
														<th>Supplier</th>
														<th>Purch Price</th>
														<th>Sell Price</th>
														<th>Margin %</th>
														<th>Disc</th>
														<th *ngFor="let pt of costReportPriceTypes">{{ pt }}</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let row of costReportRows"
														[ngClass]="{ 'bcu-row-low-margin': row.lowMargin }">
														<td class="small font-weight-bold">{{ row.stockid }}</td>
														<td class="small">{{ row.description }}</td>
														<td class="small text-muted">{{ row.mfgname }}</td>
														<td class="small text-muted">{{ row.lineid }}</td>
														<td class="small text-muted">{{ row.categoryid }}</td>
														<td class="small text-right">{{ row.materialcost | currency }}</td>
														<td class="small text-right">{{ row.labourcost | currency }}</td>
														<td class="small text-right">{{ row.overheadcost | currency }}</td>
														<td class="small text-right">{{ row.actualcost | currency }}</td>
														<td class="small text-right">{{ row.xrefcost | currency }}</td>
														<td class="small text-right">{{ row.lastcost | currency }}</td>
														<td class="small text-right">{{ row.total_qoh }}</td>
														<td class="small text-muted">{{ row.supplierno }}</td>
														<td class="small text-right">{{ row.purchprice | currency }}</td>
														<td class="small text-right">{{ row.defaultSellPrice | currency }}</td>
														<td class="small text-right" [ngClass]="{ 'text-danger font-weight-bold': row.lowMargin }">{{ row.margin }}%</td>
														<td class="small text-center">
															<mat-icon *ngIf="row.discontinued" class="text-danger" style="font-size:16px;width:16px;height:16px;">block</mat-icon>
														</td>
														<td *ngFor="let pt of costReportPriceTypes" class="small text-right">{{ row['price_' + pt] | currency }}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</ng-container>

									<div class="text-center py-5 text-muted small" *ngIf="!costReportLoading && !costReportRows.length">
										Set filters above and click <strong>Load report</strong>.
									</div>

								</div>
							</mat-tab><!-- /Tab 2: Cost Report -->

						</mat-tab-group>

					</div><!-- /.card-body -->
				</div><!-- /.card -->
			</div>
		</div>
	</div>
</div>
